import { useContext } from 'react';

import ReCaptchaContext from '@/contexts/ReCaptchaContext';

const useReCaptchaContext = () => useContext(ReCaptchaContext);

export default useReCaptchaContext;
